"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalTime = void 0;
const MAX_HOUR = 23;
const MAX_MINUTE = 59;
const MAX_SECOND = 59;
const MAX_MILLISECOND = 999;
/**
 * Represents a local time with hour, minute, second, and millisecond components.
 */
class LocalTime {
    /**
     * Creates a new instance of the LocalTime class.
     *
     * @param hour - The hour value.
     * @param minute - The minute value.
     * @param second - The second value.
     * @param millisecond - (Optional) The millisecond value.
     *
     * @throws {Error} - If any of the values are invalid.
     */
    constructor(hour, minute, second, millisecond) {
        /**
         * Validates the input of the localtime
         *
         * @param hour - Hour value.
         * @param minute - Minutes value.
         * @param second - Seconds value.
         * @param millisecond - (Optional) Milliseconds value.
         *
         * @throws {Error} - If any of the values are invalid.
         *
         * @returns {void}
         */
        this.validate = (hour, minute, second, millisecond) => {
            if (hour < 0 || hour > MAX_HOUR) {
                throw new Error('LocalTime - Invalid hour');
            }
            if (minute < 0 || minute > MAX_MINUTE) {
                throw new Error('LocalTime - Invalid minute');
            }
            if (second < 0 || second > MAX_SECOND) {
                throw new Error('LocalTime - Invalid second');
            }
            if (millisecond !== undefined && (millisecond < 0 || millisecond > MAX_MILLISECOND)) {
                throw new Error('LocalTime - Invalid millisecond');
            }
        };
        /**
         * Checks if the current LocalTime instance is equal to the specified time.
         *
         * @param time - The LocalTime instance to compare.
         *
         * @returns {boolean} - True if the current LocalTime instance is equal to the specified time, false otherwise.
         */
        this.isEqual = (time) => this.hour === time.hour && this.minute === time.minute && this.second === time.second && this.millisecond === time.millisecond;
        this.validate(hour, minute, second, millisecond);
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
    }
}
exports.LocalTime = LocalTime;
/**
 * Gets the start of time (0:00:00.000).
 *
 * @returns {LocalTime} - The LocalTime instance representing the start of time.
 */
LocalTime.getStartOfTime = () => new LocalTime(0, 0, 0, 0);
/**
 * Gets the end of time (23:59:59.999).
 *
 * @returns {LocalTime} - The LocalTime instance representing the end of time.
 */
LocalTime.getEndOfTime = () => new LocalTime(MAX_HOUR, MAX_MINUTE, MAX_SECOND, MAX_MILLISECOND);
//# sourceMappingURL=LocalTime.js.map